/* KD add-on offer — one-tap add from the cart-drawer strip (Build A, docs/addon_offer_spec.md).
   Event delegation: the strip is re-rendered by the section rendering API on every cart change.
   Analytics: Microsoft Clarity (already on store) — funnel = strip_seen -> add_clicked -> add_success.
   All Clarity calls are guarded; if Clarity is absent the offer still works. */
(function () {
  if (window.__kdAddonOfferInit) return; // guard: script may be loaded by both cart-drawer and main-cart sections
  window.__kdAddonOfferInit = true;

  // --- Clarity helpers (guarded; clarity() queues calls until the tag finishes loading) ---
  function clarityTag(k, v) { try { if (window.clarity) window.clarity('set', k, v); } catch (e) {} }
  function clarityEvent(name) { try { if (window.clarity) window.clarity('event', name); } catch (e) {} }

  // --- Funnel denominator: fire once per page when the (active) offer strip is actually viewed ---
  var seenFired = false;
  function fireStripSeen() {
    if (seenFired) return;
    seenFired = true;
    clarityTag('kd_addon_offer', 'strip_seen');
    clarityEvent('kd_addon_strip_seen');
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { fireStripSeen(); io.unobserve(en.target); }
    });
  }, { threshold: 0.5 }) : null;
  function observeStrips() {
    // only the live offer (not the post-add "done" state) counts as "seen"
    var strips = document.querySelectorAll('.kd-addon-offer:not(.kd-addon-offer--done)');
    for (var i = 0; i < strips.length; i++) {
      var s = strips[i];
      if (s.__kdSeenObserved) continue;
      s.__kdSeenObserved = true;
      if (io) io.observe(s); else fireStripSeen();
    }
  }
  observeStrips();
  // the cart sections API replaces nodes on every cart change — re-scan when cart containers mutate
  try {
    var mo = new MutationObserver(function () { observeStrips(); });
    ['cart-drawer', '#main-cart-items', '.cart__items', '#MainContent', 'main'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { childList: true, subtree: true });
    });
  } catch (e) {}

  // --- Contain the strip's size <select>: the drawer strip renders inside <cart-drawer-items>,
  // whose inherited CartItems 'change' listener would treat it as a line-quantity change and
  // fire a malformed /cart/change.js call (red cart-error banner). Nothing outside the strip
  // needs these events — stop them at the boundary. ---
  document.addEventListener('change', function (e) {
    if (e.target.closest('.kd-addon-offer')) e.stopPropagation();
  }, true);

  // --- Click: one-tap add ---
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-kd-addon-toggle]');
    if (toggle) {
      e.preventDefault();
      const offer = toggle.closest('.kd-addon-offer');
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      offer.querySelectorAll('[data-kd-addon-extra]').forEach(function (item) {
        item.hidden = isExpanded;
      });
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      toggle.textContent = isExpanded ? toggle.dataset.collapsedLabel : toggle.dataset.expandedLabel;
      return;
    }

    const btn = e.target.closest('.kd-addon-offer__add');
    if (!btn) return;
    e.preventDefault();

    const card = btn.closest('.kd-addon-offer__item');
    const select = card ? card.querySelector('.kd-addon-offer__variant') : null;
    const variantId = select ? select.value : btn.dataset.variantId;
    if (!variantId) return;

    // Funnel numerator: someone tapped +Add. Tag which add-on product, then fire the event.
    var handle = (card && card.dataset.handle) || '';
    clarityTag('kd_addon_offer', 'add_clicked');
    if (handle) clarityTag('kd_addon_product', handle);
    clarityEvent('kd_addon_add_clicked');

    btn.disabled = true;
    const cartDrawer = document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cartDrawer) {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          clarityEvent('kd_addon_add_failed'); // e.g. sold out / variant unavailable
          const err = card ? card.querySelector('.kd-addon-offer__error') : null;
          if (err) {
            err.textContent = response.description || response.message || '';
            err.style.display = 'block';
          }
          btn.disabled = false;
          return;
        }
        clarityEvent('kd_addon_add_success');
        if (cartDrawer) {
          cartDrawer.renderContents(response);
        } else {
          window.location.reload(); // cart page (no drawer): refresh to show updated lines + discount
        }
      })
      .catch(function () {
        clarityEvent('kd_addon_add_failed');
        btn.disabled = false;
      });
  });
})();
